"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldsetContentStyle = exports.LegendContainerStyle = exports.FieldsetStyle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _formField = _interopRequireDefault(require("../../__internal__/form-field/form-field.style"));

var _validationIcon = _interopRequireDefault(require("../../__internal__/validations/validation-icon.style"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _checkbox = _interopRequireDefault(require("../checkbox/checkbox.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FieldsetStyle = _styledComponents.default.fieldset`
  ${_styledSystem.margin}
  border: none;
  padding: 0;

  &&&& ${_formField.default} {
    margin-top: 0;
    margin-bottom: -1px;
  }

  & ${_checkbox.default} {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;
exports.FieldsetStyle = FieldsetStyle;
FieldsetStyle.defaultProps = {
  theme: _base.default
};
const LegendContainerStyle = _styledComponents.default.div`
  ${({
  inline
}) => inline && `
  margin-right: 32px;
  height: 34px !important;
  `}
  display: flex;
  align-items: center;
  margin-bottom: 32px;

  legend {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-right: 4px;
  }

  ${_validationIcon.default} ${_icon.default}:focus {
    outline: 2px solid #ffb500;
  }
`;
exports.LegendContainerStyle = LegendContainerStyle;
const FieldsetContentStyle = _styledComponents.default.div`
  ${({
  inline
}) => inline && "display: flex;"}
`;
exports.FieldsetContentStyle = FieldsetContentStyle;